import React, { useState, useEffect } from 'react';
import { Plus, CheckSquare } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const STATUS_COLORS = { todo: 'bg-[#475569]/20 text-[#94a3b8]', in_progress: 'bg-blue-500/20 text-blue-400', done: 'bg-green-500/20 text-green-400' };
const PRIORITY_COLORS = { low: 'text-[#475569]', medium: 'text-orange-400', high: 'text-red-400' };

export default function TasksPage() {
  const { api } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', due_date: '', priority: 'medium' });

  const loadTasks = () => api('get', '/api/admin/tasks').then(r => setTasks(r.data.tasks || []));
  useEffect(() => { loadTasks(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    await api('post', '/api/admin/tasks', form);
    toast.success('Taak aangemaakt');
    setShowCreate(false);
    setForm({ title: '', description: '', due_date: '', priority: 'medium' });
    loadTasks();
  };

  const updateStatus = async (id, status) => {
    await api('post', `/api/admin/tasks/${id}/status`, { status });
    loadTasks();
  };

  return (
    <div className="max-w-4xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Taken</h1>
        <button onClick={() => setShowCreate(!showCreate)} className="flex items-center gap-2 bg-[#D4A017] hover:bg-[#B8860B] text-[#0f172a] font-bold px-4 py-2 rounded-xl text-sm">
          <Plus size={16} /> Taak aanmaken
        </button>
      </div>

      {showCreate && (
        <div className="bg-[#0f172a] rounded-2xl border border-[#D4A017]/30 p-6 mb-6">
          <form onSubmit={handleCreate} className="space-y-4">
            <div><label className="text-[#94a3b8] text-sm mb-1 block">Titel *</label>
              <input value={form.title} onChange={e => setForm(f => ({...f, title: e.target.value}))} required placeholder="Taakomschrijving"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-[#475569] focus:outline-none focus:border-[#D4A017]" /></div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div><label className="text-[#94a3b8] text-sm mb-1 block">Deadline</label>
                <input type="date" value={form.due_date} onChange={e => setForm(f => ({...f, due_date: e.target.value}))}
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#D4A017]" /></div>
              <div><label className="text-[#94a3b8] text-sm mb-1 block">Prioriteit</label>
                <select value={form.priority} onChange={e => setForm(f => ({...f, priority: e.target.value}))}
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#D4A017]">
                  <option value="low">Laag</option><option value="medium">Middel</option><option value="high">Hoog</option>
                </select></div>
            </div>
            <div className="flex gap-3">
              <button type="submit" className="bg-[#D4A017] text-[#0f172a] font-bold px-6 py-2 rounded-lg text-sm">Aanmaken</button>
              <button type="button" onClick={() => setShowCreate(false)} className="bg-white/10 text-white px-6 py-2 rounded-lg text-sm">Annuleren</button>
            </div>
          </form>
        </div>
      )}

      <div className="space-y-3">
        {tasks.length === 0 ? (
          <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-8 text-center">
            <CheckSquare className="w-10 h-10 text-[#475569] mx-auto mb-3" />
            <p className="text-[#64748b]">Geen taken</p>
          </div>
        ) : tasks.map(t => (
          <div key={t.id} className="bg-[#0f172a] rounded-2xl border border-white/5 p-5 flex items-start gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className={`font-semibold text-sm ${t.status === 'done' ? 'text-[#475569] line-through' : 'text-white'}`}>{t.title}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${PRIORITY_COLORS[t.priority]}`}>{t.priority}</span>
              </div>
              {t.due_date && <p className="text-[#475569] text-xs">Deadline: {t.due_date}</p>}
            </div>
            <select value={t.status} onChange={e => updateStatus(t.id, e.target.value)}
              className={`text-xs px-3 py-1.5 rounded-full border-none focus:outline-none cursor-pointer ${STATUS_COLORS[t.status]}`}>
              <option value="todo">To do</option>
              <option value="in_progress">Bezig</option>
              <option value="done">Klaar</option>
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
